import { Switch } from "@mui/material";
import React from "react";

const CreateRoleForm = () => {
  return (
    <div className="create-role-form">


      <div className="row mb-4">
        <div className="col-md-6">
          <label className="form-label">Role Name</label>
          <input
            type="text"
            className="universal-input"
            style={{ width: "100%" }}
            placeholder="Enter role name"
          />
        </div>
        <div className="col-md-6">
          <label className="form-label">Role Description</label>
          <input
            type="text"
            className="universal-input"
            style={{ width: "100%" }}
            placeholder="Brief description"
          />
        </div>
      </div>

      <div className="permissions-section">
        <label className="form-label mb-3">Permissions</label>

        <div className="row g-3">
          <div className="col-md-6">
            <div className="permission-item d-flex justify-content-between align-items-center">
              <span className="color-white font-weight-200 fornt-14">View Forms</span>
              <label className="switch">
                <Switch />

              </label>
            </div>
          </div>
          <div className="col-md-6">
            <div className="permission-item d-flex justify-content-between align-items-center">
              <span className="color-white font-weight-200 fornt-14">Edit Forms</span>
              <label className="switch">
                <Switch />

              </label>
            </div>
          </div>

          <div className="col-md-6">
            <div className="permission-item d-flex justify-content-between align-items-center">
              <span className="color-white font-weight-200 fornt-14">Approve Forms</span>
              <label className="switch">
                <Switch />

              </label>
            </div>
          </div>
          <div className="col-md-6">
            <div className="permission-item d-flex justify-content-between align-items-center">
              <span className="color-white font-weight-200 fornt-14">Reject Forms</span>
              <label className="switch">
                <Switch />

              </label>
            </div>
          </div>

          <div className="col-md-6">
            <div className="permission-item d-flex justify-content-between align-items-center">
              <span className="color-white font-weight-200 fornt-14">Request Edit</span>
              <label className="switch">
                <Switch />

              </label>
            </div>
          </div>
          <div className="col-md-6">
            <div className="permission-item d-flex justify-content-between align-items-center">
              <span className="color-white font-weight-200 fornt-14">Export Data</span>
              <label className="switch">
                <Switch />

              </label>
            </div>
          </div>
        </div>
      </div>


    </div>
  );
};

export default CreateRoleForm;
